import { arrayResultMemoizeOptions } from 'checkout/lib/utils/misc/arrayResultMemoizeOptions'
import { excludeNullOrUndefined } from 'checkout/utils'
import { isCarHireItem } from 'lib/checkout'
import createSelector from 'lib/createSelector'
import { sum } from 'lib/arrayUtils'
import { getCarHireItemView } from 'checkout/lib/utils/carHire/view'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import moment from 'moment'
import { pluralizeToString } from 'lib/pluralize'

export const getCarHireItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.CarHireItem> => items.filter(isCarHireItem),
  arrayResultMemoizeOptions,
)

export const getCarHireItemsView = createSelector(
  (state: App.State) => getCarHireItems(state),
  (
    carHireItems,
  ): App.WithDataStatus<Array<App.Checkout.CarHireItemView>> => {
    const itemViews = carHireItems.map(item => {
      return getCarHireItemView(item)
    })

    return {
      hasRequiredData: itemViews.every(Boolean),
      data: itemViews.filter(excludeNullOrUndefined),
    }
  },
)

export const getCarHireBreakdownView = createSelector(
  getCarHireItemsView,
  (viewWithStatus): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    if (viewWithStatus.data.length === 0) { return { hasRequiredData: viewWithStatus.hasRequiredData, data: [] } }

    const carHireBreakdownView = {
      title: viewWithStatus.data[0].model,
      price: sum(viewWithStatus.data.map(i => i?.price ?? 0)),
      additionalInfoText: [],
      items: viewWithStatus.data.filter(excludeNullOrUndefined).map<App.Checkout.ItemBreakdownView>(carView => {
        const offer = carView.item.offer
        const isSameLocation = offer.pickUp.name === offer.dropOff.name
        return {
          title: isSameLocation ? `Pick up and drop-off at ${offer.pickUp.name}` : `Pick up at ${offer.pickUp.name} and drop-off at ${offer.dropOff.name}`,
          price: carView.item.totalPrice,
          itemType: 'car_hire',
          additionalInfoText: [
            `${moment(carView.item.pickUpDate).format(DMY_CASUAL_FORMAT)}, ${carView.item.pickUpTime} → ${moment(carView.item.dropOffDate).format(DMY_CASUAL_FORMAT)}, ${carView.item.dropOffTime} · ${pluralizeToString('day', offer.duration)}`,
          ],
          additionalElements: [],
          taxesAndFees: carView.taxesAndFees,
        }
      }),
    }

    return {
      hasRequiredData: true,
      data: [carHireBreakdownView],
    }
  },
)
